module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/babel-runtime/core-js/object/define-property.js
 ** module id = 203
 ** module chunks = 1
 **/